import React, { useEffect, useRef, useState } from 'react';
import Select from 'components/Select';

const { Option } = Select;
const initialState = { status: 'loading', options: [] };

// Manual creation uses the full list returned by the configured component query,
// never a search result or legacy default. Other selectors retain their behavior.
const CreateOrderTemplateField = ({
	componentId,
	paramValues,
	selectionContextKey,
	value,
	disabled,
	placeholder,
	onChange,
	onTemplateSelectionStateChange,
	getProcessedComponentSqlData,
}) => {
	const [state, setState] = useState(initialState);
	const [retry, setRetry] = useState(0);
	const callbacks = useRef();
	callbacks.current = {
		onChange,
		onTemplateSelectionStateChange,
		getProcessedComponentSqlData,
	};
	const paramsKey = JSON.stringify(paramValues || {});

	useEffect(() => {
		let active = true;
		const publish = next => {
			if (!active) return;
			setState(next);
			callbacks.current.onTemplateSelectionStateChange?.(next);
		};
		callbacks.current.onChange(undefined);
		publish({ status: disabled ? 'idle' : 'loading', options: [] });
		if (!disabled) {
			(async () => {
				try {
					const options = await callbacks.current.getProcessedComponentSqlData({
						componentId,
						paramValues: JSON.parse(paramsKey),
						returnKey: 'options',
					});
					if (!active) return;
					if (!Array.isArray(options))
						throw new Error('Invalid template response');
					publish({ status: options.length ? 'ready' : 'empty', options });
					if (options.length === 1) callbacks.current.onChange(options[0].id);
				} catch (error) {
					publish({ status: 'error', options: [] });
				}
			})();
		}
		return () => {
			active = false;
		};
	}, [componentId, selectionContextKey, paramsKey, disabled, retry]);

	return (
		<>
			<Select
				width='100%'
				aria-label='Plantilla de creación de orden'
				showSearch
				optionFilterProp='children'
				disabled={disabled || state.status !== 'ready'}
				loading={state.status === 'loading'}
				placeholder={placeholder || 'Seleccione una plantilla'}
				value={value}
				onChange={id => {
					if (
						state.status === 'ready' &&
						state.options.some(option => String(option.id) === String(id))
					)
						onChange(id);
				}}
			>
				{state.options.map(option => (
					<Option key={option.id} value={option.id}>
						{option.name}
					</Option>
				))}
			</Select>
			{state.status === 'empty' && (
				<div role='status'>
					No hay plantillas de creación compatibles configuradas para este
					departamento y destino de orden.
				</div>
			)}
			{state.status === 'error' && (
				<div role='alert'>
					No se pudieron cargar las plantillas.{' '}
					<button type='button' onClick={() => setRetry(count => count + 1)}>
						Reintentar
					</button>
				</div>
			)}
		</>
	);
};

export default CreateOrderTemplateField;
